var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"brand",attrs:{"for":_vm.value.Value}},[_c('input',{staticClass:"u-hidden",attrs:{"type":"radio","name":"Brands","id":_vm.value.Value},domProps:{"checked":_vm.value.IsSelected},on:{"click":_vm.setSelectedItem}}),_vm._v(" "),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-159d8e28","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/filters/FilterBrandsElement.vue
// module id = null
// module chunks = 